export interface Recipient {
  recipientId: string;
  recipientType: string;
  isRead: boolean;
  isArchived?: boolean;
}

interface RecipientReqBody {
  recipientId: string;
  isRead?: boolean;
  isArchived?: boolean;
}

export enum NotificationTypes {
  SKILL_ADDED = "SKILL_ADDED",
  GENERAL = "GENERAL",
  CHECKLIST_CREATION = "CHECKLIST_CREATION",
  PROGRESS_CREATION = "PROGRESS_CREATION",
  UPDATE_CHECKLIST = "UPDATE_CHECKLIST",
  NEW_LEARNING_MODULE_ASSIGNED = "NEW_LEARNING_MODULE_ASSIGNED",
  ASSIGN_NEW_SECTION = "ASSIGN_NEW_SECTION",
  ASSIGNMENT_IN_REVIEW = "ASSIGNMENT_IN_REVIEW",
  ASSIGNMENT_COMPLETED = "ASSIGNMENT_COMPLETED",
  PROGRESS_DEADLINE_EXCEED = "PROGRESS_DEADLINE_EXCEED",
  CHECKLIST_COMPLETED = "CHECKLIST_COMPLETED",
  PROGRESS_CLOSED_WITHOUT_COMPLETING_TASKS = "PROGRESS_CLOSED_WITHOUT_COMPLETING_TASKS",
  UPDATE_CHECKLIST_BY_MANAGER = "UPDATE_CHECKLIST_BY_MANAGER",
  ASSIGN_NEW_ASSIGNMENT = "ASSIGN_NEW_ASSIGNMENT",
  ASSISTANCE_REQUESTED = "ASSISTANCE_REQUESTED",
  ASSIGNMENT_ACCEPTANCE_REQUIRED = "ASSIGNMENT_ACCEPTANCE_REQUIRED",
  ASSIGNMENT_REJECTED = "ASSIGNMENT_REJECTED",
  ASSIGNMENT_ACCEPTED = "ASSIGNMENT_ACCEPTED",
}

export interface Notification {
  _id: string;
  message: string;
  title: string;
  recipients: Recipient[];
  notificationType: NotificationTypes;
  createdAt: Date;
  status: string;
  referenceId?: string;
  docType?: string;
}

export interface NotificationUpdateBody {
  notificationIds: string[];
  recipients?: RecipientReqBody[];
  status?: string;
}

export interface UpdateNotificationRequest {
  documentId: string;
  documentType: 'CompanyDoc' | 'ProcedureDoc' | 'PolicyDoc' | 'LearningModule' | 'LearningSection';
  permissions: string[];
}
